import { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";

import notification, {
    Error as notificationError,
} from "../../../Modules/Notifications";
import confirm from "../../../Modules/AlertConfirm";

import api from "../../../service/api";

import useLoading from "../../../hooks/useLoading";

function useHomologatedBrand() {
    const [nome, setNome] = useState("");
    const [imagem, setImagem] = useState({});
    const [arquivo, setArquivo] = useState({});

    const { id } = useParams();

    const history = useHistory();

    const { loading } = useLoading();

    const show = useCallback(() => {
        async function show() {
            const idLoading = loading();

            try {
                const response = await api.get(`/marcas-homologadas/${id}`);

                const data = response.data;

                setNome(data.nome);

                const imagem = {
                    id: response.data.imagem.id,
                    preview: `${api.defaults.baseURL}${response.data.imagem.url}`,
                };

                setImagem(imagem);

                const arquivo = {
                    id: response.data.arquivo.id,
                    preview: `${api.defaults.baseURL}${response.data.arquivo.url}`,
                };

                setArquivo(arquivo);

                loading(idLoading);
            } catch (error) {
                notificationError(error);

                loading(idLoading);
            }
        }

        show();
    }, [id, loading]);

    useEffect(() => {
        if (id) show();
    }, [show, id]);

    function handleOnChangeNome({ target }) {
        const { value } = target;

        setNome(value);
    }

    function handleOnChangeImagem(files) {
        const file = files[0];

        if (imagem.id) {
            confirm(
                "Alterar Imagem",
                "Tem certeza que deseja alterar ?",
                async () => {
                    const idLoading = loading();

                    try {
                        await api.delete(`/upload/files/${imagem.id}`);
                        const response = await uploadFile(file);
                        await api.put(`/marcas-homologadas/${id}`, {
                            imagem: response,
                        });
                        show();
                        notification("success", "Imagem alterada");

                        loading(idLoading);
                    } catch (error) {
                        notificationError(error);

                        loading(idLoading);
                    }
                }
            );
        } else {
            setImagem({
                file,
                preview: URL.createObjectURL(file),
            });
        }
    }

    function handleOnDeleteImagem() {
        if (imagem.id) {
            notification("warning", "Não é possivel remover");
        } else {
            setImagem({});
        }
    }

    function handleOnChangeArquivo(files) {
        const uploadedFile = files[0];
        if (arquivo.id) {
            confirm(
                "Alterar Arquivo",
                "Tem certeza que deseja alterar ?",
                async () => {
                    const idLoading = loading();

                    try {
                        await api.delete(`/upload/files/${arquivo.id}`);
                        const response = await uploadFile(uploadedFile);
                        await api.put(`/marcas-homologadas/${id}`, {
                            arquivo: response,
                        });
                        show();
                        notification("success", "Arquivo alterado");

                        loading(idLoading);
                    } catch (error) {
                        notificationError(error);

                        loading(idLoading);
                    }
                }
            );
        } else {
            setArquivo({
                file: uploadedFile,
                preview: URL.createObjectURL(uploadedFile),
            });
        }
    }

    function handleOnDeleteArquivo() {
        if (arquivo.id) {
            notification("warning", "Não é possivel remover");
        } else {
            setArquivo({});
        }
    }

    function handleValidate() {
        if (!nome) {
            return { status: false, message: "Nome é obrigatório" };
        }

        if (Object.keys(imagem).length === 0) {
            return { status: false, message: "Imagem é obrigatório" };
        }

        if (Object.keys(arquivo).length === 0) {
            return { status: false, message: "Arquivo é obrigatório" };
        }

        return { status: true };
    }

    const uploadFile = async (file) => {
        const idLoading = loading();

        let data = new FormData();
        data.append(`files`, file);
        const response = await api.post("/upload", data);

        loading(idLoading);

        return response.data[0];
    };

    async function create(data) {
        const idLoading = loading();

        try {
            await api.post("/marcas-homologadas", data);

            notification("success", "Marca homologada cadastrado");

            loading(idLoading);
        } catch (error) {
            notificationError(error);

            loading(idLoading);
        }
    }

    async function update(id, data) {
        const idLoading = loading();

        try {
            await api.put(`/marcas-homologadas/${id}`, data);

            notification("success", "Marca homologada alterado");

            loading(idLoading);
        } catch (error) {
            notificationError(error);

            loading(idLoading);
        }
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const validate = handleValidate();
        if (!validate.status) {
            return notification("warning", validate.message);
        }

        if (!imagem.id) {
            var uploadedImagem = await uploadFile(imagem.file);
        }

        if (!arquivo.id) {
            var uploadedArquivo = await uploadFile(arquivo.file);
        }

        if (!id) {
            await create({
                nome,
                imagem: uploadedImagem,
                arquivo: uploadedArquivo,
            });
        } else {
            await update(id, { nome });
        }

        history.push("/ctop/marcas-homologadas");
    }

    function destroy() {
        confirm(
            "Remover Marca Homologada",
            "Tem certeza que deseja remover ?",
            async () => {
                const idLoading = loading();

                try {
                    await api.delete(`/marcas-homologadas/${id}`);

                    notification("success", "Marca Homologada removido");
                    history.push("/ctop/marcas-homologadas");

                    loading(idLoading);
                } catch (error) {
                    notificationError(error);

                    loading(idLoading);
                }
            }
        );
    }

    return {
        nome,
        imagem,
        arquivo,
        handleOnChangeNome,
        handleOnChangeImagem,
        handleOnDeleteImagem,
        handleOnChangeArquivo,
        handleOnDeleteArquivo,
        handleSubmit,
        destroy,
    };
}

export default useHomologatedBrand;
